import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { getJwtPayload } from "../../../utilities/getJwtPayload";

import { Box, Tooltip } from "@mui/material";
import HeaderBarIconMenu from "./HeaderBarIconMenu.js";
import HamburgerButton from "./HeaderBarButtons/HamburgerButton.js";

import useMediaQuery from '@mui/material/useMediaQuery';

export default function HeaderBar({...params}) {

    let navigate = useNavigate();
    const [hamburgerButtonState, setHamburgerButtonState] = useState('default')

    const { getAccessTokenSilently } = useAuth0();
    const [isAdmin, setIsAdmin] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    
    useEffect(() => {
        getAccessTokenSilently()
            .then(accessToken => {
                const payload = getJwtPayload(accessToken);
                if (
                    payload.permissions?.includes("read:users") &&
                    payload.permissions?.includes("write:users") &&
                    payload.permissions?.includes("read:roles")
                ) {
                    setIsAdmin(true);
                }
                if (payload.permissions?.includes("write:channels")) {
                    setCanEdit(true);
                }
            })
            .catch(err => {
                console.error("Failed to fetch JWT payload:", err);
            });
    }, [getAccessTokenSilently]);


    function sinclairLogoOnClick(event) {
        event.preventDefault();
        navigate("/");
    }

    const isDesktop = useMediaQuery('(min-width:1010px)');
    const toolTipMessage = "Click here to go back to the home page";

    const page = params.page
    if (page === "ChannelPage" || page === 'EditPage') var channelID = params.channelID

    return (
        <>
            <Box position={'sticky'} 
                top={'0'} 
                display={'flex'} 
                alignItems={'center'} 
                justifyContent={'space-between'}
                width={'100%'}
                zIndex={10} 
                sx={{backgroundColor: 'NavigationBar.background'}}>
        
                <Tooltip title={toolTipMessage} placement="bottom">
                    <Box 
                        component="img" 
                        src="/logos/station-portal-logo.svg" 
                        backgroundColor='NavigationBar.background'
                        width={'238px'} 
                        height={'95px'}
                        zIndex={100} 
                        flexShrink={0}
                        id={"SBGLogo"}
                        display={'flex'}
                        justifySelf={'flex-start'}
                        padding={0}
                        onClick={(event) => sinclairLogoOnClick(event)}
                    />
                </Tooltip>

                {isDesktop ? (
                    <>
                        {(page === "ChannelPage" || page === "EditPage") ? (
                            <HeaderBarIconMenu isAdmin={isAdmin} canEdit={canEdit} page={page} channelID={channelID}/>
                        ) : (page) ? (
                            <HeaderBarIconMenu isAdmin={isAdmin} canEdit={canEdit} page={page} />
                        ) : (
                            <HeaderBarIconMenu isAdmin={isAdmin} canEdit={canEdit} />
                        )}

                        <Box 
                            width={'238px'} //empty box of size=portal_logo for centering purposes
                            height={'95px'}
                            zIndex={100} 
                            display={'flex'}
                            justifySelf={'flex-end'}
                            padding={0}
                            flexShrink={0}
                            id={'EmptyCenteringBox'}
                            backgroundColor={'NavigationBar.background'}
                        />
                    </>
                ) : (
                    <>
                        {(page === "ChannelPage" || page === "EditPage") ? (
                            <HamburgerButton page={page} channelID={channelID} isAdmin={isAdmin} canEdit={canEdit} hamburgerButtonState={hamburgerButtonState} setHamburgerButtonState={setHamburgerButtonState}  />
                        ) : (page) ? (
                            <HamburgerButton page={page} isAdmin={isAdmin} canEdit={canEdit} hamburgerButtonState={hamburgerButtonState} setHamburgerButtonState={setHamburgerButtonState} />
                        ) : (
                            <HamburgerButton isAdmin={isAdmin} canEdit={canEdit} hamburgerButtonState={hamburgerButtonState} setHamburgerButtonState={setHamburgerButtonState} />
                        )}
                    </>
                )}
            </Box>
        </>
    );
}
